<template>
  <section class="kmutt-contact">
    <div class="container">
      <h1 class="text-center mb-5">{{data.header}}</h1>
      <div class="row mb-5">
        <div class="col-md-7">
          <div class="kmutt-contact-info">
            <ul>
              <li class="address"><p class="small-blankline"><b>{{data.address.header}} : </b></p>
                <span v-html="data.address.detail"></span></li>
            </ul>
          </div>
        </div>
        <div class="col-md-5">
          <div class="kmutt-contact-info">
            <ul>
              <li class="phone" style="margin: 0px;">
                <div class="row px-0 mx-0">
                  <b class="mr-3">Tel : </b>
                  <div>(+66)0-2-470-8389<br>(+66)0-2-470-8386</div>
                </div>
              </li>
              <li class="fax"><b>Fax : </b>(+66)02-470-8387</li>
              <li class="email"><a href="mailto:esc@mail.kmutt.ac.th">esc@mail.kmutt.ac.th</a></li>
              <li class="url"><a href="http://www.kmutt.ac.th/GiftEd">http://www.kmutt.ac.th/GiftEd</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9 mx-auto">
            <a target="_blank" href="https://goo.gl/maps/9WcvnLTd7345neaR7" rel="noopener noreferrer">
              <img :src="`/${this.$staticPath}/${data.map}`" class="w-100 mb-4 contact-map" title="คลิ๊กเพื่อเปิดแผนที่">
            </a>
            <p class="text-center">( {{data.mapNotice}} )</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {

    }
  }
}
</script>

<style scoped>
  @import url('../../../static/css/home-style/contact.css');
</style>



// WEBPACK FOOTER //
// src/components/HOME/Contact.vue